const getDefaultState = () => ({
  typeDepense: null,
  typesDepenseAll: null,
  prestation: null,
  prestationsAll: null,
  tarification: null,
  montantDepense: 0,
  sousPrestations: [],
  isOptam: false,
  isOptamVisible: false,
  isAlsaceMoselle: false,
  typeRegime: null,
});

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    RESET_STATE(state) {
      const newState = getDefaultState();

      // On garde la valeur actuelle
      newState.typesDepenseAll = state.typesDepenseAll;
      newState.typeRegime = state.typeRegime;

      Object.assign(state, newState);
    },
    SET_TYPEDEPENSE(state, value) {
      state.typeDepense = value;
    },
    SET_TYPESDEPENSEALL(state, value) {
      state.typesDepenseAll = value;
    },
    SET_PRESTATION(state, value) {
      state.prestation = value;
    },
    SET_PRESTATIONSALL(state, value) {
      state.prestationsAll = value;
    },
    SET_TARIFIACATION(state, value) {
      state.tarification = value;
    },
    SET_MONTANTDEPENSE(state, value) {
      state.montantDepense = value;
    },
    SET_SOUSPRESTATIONS(state, value) {
      state.sousPrestations = value;
    },
    SET_MONTANTSOUSPRESTATIONS(state, { index, value }) {
      state.sousPrestations[index].montant = value;
    },
    SET_OPTAM(state, value) {
      state.isOptam = value;
    },
    SET_OPTAMVISIBLE(state, value) {
      state.isOptamVisible = value;
    },
    SET_REGIME(state, value) {
      state.isAlsaceMoselle = value;
    },
    SET_TYPEREGIME(state, value) {
      state.typeRegime = value;
    },
  },

  actions: {
    updateTypeDepense({ commit }, value) {
      commit("SET_TYPEDEPENSE", value);
    },
    updateTypesDepenseAll({ commit }, value) {
      commit("SET_TYPESDEPENSEALL", value);
    },
    updatePrestation({ commit }, value) {
      commit("SET_PRESTATION", value);
    },
    updatePrestationsAll({ commit }, value) {
      commit("SET_PRESTATIONSALL", value);
    },
    updateTarification({ commit }, value) {
      commit("SET_TARIFIACATION", value);
    },
    updateMontantDepense({ commit }, value) {
      commit("SET_MONTANTDEPENSE", value);
    },
    updateSousPrestations({ commit }, value) {
      commit("SET_SOUSPRESTATIONS", value);
    },
    updateMontantSousPrestations({ commit }, value) {
      commit("SET_MONTANTSOUSPRESTATIONS", value);
    },
    updateOptam({ commit }, value) {
      commit("SET_OPTAM", value);
    },
    updateOptamVisible({ commit }, value) {
      commit("SET_OPTAMVISIBLE", value);
    },
    updateRegimeAlsaceMoselle({ commit }, value) {
      commit("SET_REGIME", value);
    },
    updateTypeRegime({ commit }, value) {
      commit("SET_TYPEREGIME", value);
    },
  },

  getters: {
    typeDepense: (state) => state.typeDepense,
    typesDepenseAll: (state) => state.typesDepenseAll,
    prestation: (state) => state.prestation,
    prestationsAll: (state) => state.prestationsAll,
    tarification: (state) => state.tarification,
    montantDepense: (state) => state.montantDepense,
    sousPrestations: (state) => state.sousPrestations,
    isOptam: (state) => state.isOptam,
    isOptamVisible: (state) => state.isOptamVisible,
    isAlsaceMoselle: (state) => state.isAlsaceMoselle,
    typeRegime: (state) => state.typeRegime,
  },
};
